import axios from "axios"
import { API_BASE_URL } from "../config"

export const getMedicalRecordDetectListWeekly = async (id: string) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/medical_record/get_medical_record_detect_list_weekly`, {
        session_code: localStorage.getItem("session_code"),
        id: id
      })

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
